import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const getI18n = (translations, locale) => {
  const resources = {
    en: { translation: translations?.en },
  };

  Object.keys?.(translations)?.map(lang => {
    if (lang === 'loading') {
      return;
    }
    resources[lang] = {
      translation: translations?.[lang],
    };
  });
  i18n.use(initReactI18next).init({
    resources: resources,
    lng: locale,
    fallbackLng: 'en',
    interpolation: { escapeValue: true },
  });

  return i18n;
};

export default getI18n;
